/** Freemium v2 value-moment lock panel. Fires paywall_view on mount and
 * paywall_click when the CTA is pressed, then routes to /billing. */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { trackPaywall } from "@/lib/analytics";

const LockPanel = ({ wall, title, body, cta = "Unlock with Pro", secondaryLabel, onSecondary, className = "" }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (wall) trackPaywall("view", wall);
  }, [wall]);

  return (
    <div
      data-testid={`lock-panel-${wall}`}
      className={`relative rounded-2xl border-2 border-primary/30 bg-gradient-to-br from-primary/10 to-transparent p-8 text-center ${className}`}
    >
      <div className="w-14 h-14 rounded-2xl bg-primary/20 flex items-center justify-center mx-auto mb-4">
        <Lock className="w-7 h-7 text-primary" />
      </div>
      {title && <h3 className="text-xl font-bold mb-2" data-testid={`lock-title-${wall}`}>{title}</h3>}
      {body && <p className="text-muted-foreground text-sm mb-6 max-w-md mx-auto">{body}</p>}
      <div className="flex items-center justify-center gap-3 flex-wrap">
        <Button
          data-testid={`lock-cta-${wall}`}
          className="rounded-full glow-primary"
          onClick={() => { if (wall) trackPaywall("click", wall); navigate("/billing"); }}
        >
          {cta}
        </Button>
        {secondaryLabel && (
          <Button variant="outline" className="rounded-full" data-testid={`lock-secondary-${wall}`} onClick={onSecondary}>
            {secondaryLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default LockPanel;
